if (!customElements.get('wk-gummies-purchase')) {
  class WKGummiesPurchase extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.root = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
      this.form = document.getElementById(this.dataset.formId);
      if (!this.root || !this.form) return;
      try { this.config = JSON.parse(this.querySelector('[data-wk-config]').textContent); }
      catch { return; }
      this.abort = new AbortController();
      this.toggle = this.querySelector('.wk-refill-toggle');
      this.mode = this.dataset.defaultMode === 'onetime' ? 'onetime' : 'subscription';
      const options = { signal: this.abort.signal };
      this.toggle.hidden = this.dataset.showToggle === 'false';
      this.toggle.addEventListener('click', () => {
        this.mode = this.mode === 'subscription' ? 'onetime' : 'subscription';
        this.update(true);
      }, options);
      this.root.addEventListener('change', event => {
        if (event.target.matches('input[name="quantity"], input[name="id"]')) this.update(true);
      }, options);
      this.form.addEventListener('submit', event => this.prepareSubmit(event), { ...options, capture: true });
      this.root.addEventListener('click', event => {
        if (event.target.closest('[data-skip-cart-button="true"], [id^="SectionAtcBtn-"], .sticky-atc__button')) this.prepareSubmit(event);
      }, { ...options, capture: true });
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }

    selectedOffer() {
      const selected = this.root.querySelector('quantity-breaks input[name="quantity"]:checked');
      return this.config.offers.find(offer => String(offer.quantity) === selected?.value) || this.config.offers[0];
    }

    renderText(template, tokens) {
      return String(template || '').replace(/\[(?:quantity|price|compare_price|amount_saved|amount_saved_rounded|price_each|compare_price_each)\]/g, token => tokens[token] ?? token);
    }

    update(announce = false) {
      const selected = this.selectedOffer();
      if (!selected) { this.toggle.hidden = true; return; }
      if (this.mode === 'subscription' && !selected.subscription.priceAvailable && selected.onetime.priceAvailable) this.mode = 'onetime';
      if (this.mode === 'onetime' && !selected.onetime.priceAvailable && selected.subscription.priceAvailable) this.mode = 'subscription';
      this.toggle.setAttribute('aria-checked', String(this.mode === 'subscription'));
      this.toggle.disabled = !selected.subscription.priceAvailable || !selected.onetime.priceAvailable;
      window.__wkSubMode = this.mode;
      for (const offer of this.config.offers) {
        const card = this.root.querySelector(`quantity-breaks label[data-input="input_${offer.index}"]`);
        if (!card) continue;
        const values = offer[this.mode];
        for (const element of card.querySelectorAll('[data-text]')) {
          let template = element.dataset.text;
          if (element.classList.contains('quantity-break__price')) template = offer.priceTemplate;
          if (element.classList.contains('quantity-break__compare-price')) template = offer.compareTemplate;
          element.innerHTML = this.renderText(template, values.tokens);
        }
        const priceElement = card.querySelector('.quantity-break__price');
        if (!values.priceAvailable && priceElement) priceElement.textContent = this.config.unavailable;
        const compareElement = card.querySelector('.quantity-break__compare-price');
        const manualCompare = offer.compareTemplate.trim() && !offer.compareTemplate.includes('[');
        if (compareElement) compareElement.classList.toggle('hidden', !values.priceAvailable || (!manualCompare && values.compare <= values.price));
      }
      this.syncForm(selected);
      const values = selected[this.mode];
      for (const price of this.root.querySelectorAll('[data-wk-main-price]')) {
        price.classList.toggle('price--on-sale', values.priceAvailable && values.compare > values.price);
        for (const node of price.querySelectorAll('.price__regular .price-item, .price__sale .price-item--sale')) node.innerHTML = values.priceAvailable ? values.tokens['[price]'] : this.config.unavailable;
        for (const node of price.querySelectorAll('.price__compare-price .price-item')) node.innerHTML = values.tokens['[compare_price]'];
      }
      for (const price of this.root.querySelectorAll('[class^="main-atc-price-span-"]')) price.innerHTML = values.priceAvailable ? values.tokens['[price]'] : this.config.unavailable;
      const button = this.form.querySelector('[name="add"]');
      if (button) {
        const blocked = !values.priceAvailable || !selected.inStock;
        if (blocked) { button.disabled = true; button.dataset.wkDisabled = 'true'; }
        else if (button.dataset.wkDisabled === 'true') { button.disabled = false; delete button.dataset.wkDisabled; }
      }
      if (announce) {
        const displayedPrice = this.root.querySelector(`quantity-breaks label[data-input="input_${selected.index}"] .quantity-break__price`)?.textContent.trim() || values.tokens['[price]'];
        this.querySelector('[data-wk-status]').textContent = `${this.mode === 'subscription' ? 'Subscribe & Save' : 'One-time purchase'}: ${displayedPrice}`;
      }
      this.dispatchEvent(new CustomEvent('wk:purchase-change', { bubbles: true, detail: { mode: this.mode, variantId: selected.variantId, sellingPlanId: this.mode === 'subscription' ? selected.planId : null } }));
    }

    syncForm(offer) {
      const id = this.form.querySelector('[name="id"]');
      if (id && offer.variantId) id.value = offer.variantId;
      let plan = this.form.querySelector('.wk-selling-plan, [name="selling_plan"]');
      if (!plan) {
        plan = document.createElement('input');
        plan.type = 'hidden';
        plan.className = 'wk-selling-plan';
        this.form.appendChild(plan);
      }
      const subscription = this.mode === 'subscription' && offer.planId;
      plan.disabled = !subscription;
      plan.value = subscription ? offer.planId : '';
      if (subscription) plan.name = 'selling_plan';
      else plan.removeAttribute('name');
    }

    prepareSubmit(event) {
      this.update();
      const offer = this.selectedOffer();
      if (offer?.inStock && offer[this.mode].priceAvailable) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const error = this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (error) {
        error.hidden = false;
        const message = error.querySelector('.product-form__error-message');
        if (message) message.textContent = this.config.unavailable;
      }
    }
  }
  customElements.define('wk-gummies-purchase', WKGummiesPurchase);
}
